import { render, staticRenderFns } from "./ParcelCard.vue?vue&type=template&id=9fee71d8&"
import script from "./ParcelCard.vue?vue&type=script&lang=ts&"
export * from "./ParcelCard.vue?vue&type=script&lang=ts&"
import style0 from "./ParcelCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports